import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { handleGoogleAuth, handleOutlookAuth, handleYahooAuth } from "components/CalendarIntegrationOptions";

export default function CalendarConnect() {
  const { provider } = useParams();

  useEffect(() => {
    if (provider === "google") handleGoogleAuth();
    if (provider === "outlook") handleOutlookAuth();
    if (provider === "yahoo") handleYahooAuth();
  }, [provider]);

  return <p>Redirecting to {provider} calendar...</p>;
}
